import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, ExcelService, PurchaseReportService } from "../../../services/index";
import { ocrDcPrint } from "./../../Purchase/ocrDc/ocrDcPrint";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./FactoryDelVsProcessReport.html",
})
export class FactoryDelVsProcess implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  backbutExists: boolean = false;
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList: any;
  codeList: any;
  widthList: any[];
  total_days: any;
  tot_days: any = 0;
  working_days: any = 0;
  year_balance: any = 0;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    groupby: "MONTH_WISE",
    fin_id: "",
    month: "",
    months: "",
    date: "",
    act_days: "",
    bal_days: "",
    plan_qty: "",
    work_days: "",
    year_qty: "",
    tot_days: "",
    dc_no: "",
    dc_date: "",
    yr_plan: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Annual Factory Del Plan VS Process Report",
    columns: [],
    rows: [],
  };
  colorList = [
    "lightcyan",
    "bisque",
    "lightblue",
    "lightgoldenrodyellow",
    "thistle"
  ];

  partyList = [];
  exceldata: any;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  bsModalRef: BsModalRef;
  onCellClick(event) {
    let row = event.row;
    if (this.filter.groupby == 'MONTH_WISE') {
      // this.working_days = row.work_days;
      // this.year_balance = row.yr_plan;
      this.filter.yr_plan = row.yr_plan;
      this.filter.month = row.month;
      this.filter.months = (('0' + (row.months)).slice(-2));
      this.filter.act_days = row.act_days;
      this.filter.plan_qty = row.plan_qty;
      this.filter.work_days = row.work_days;
      this.filter.bal_days = row.bal_days;
      this.filter.groupby = 'DATE_WISE';
    }
    // else if (this.filter.groupby == 'DC_WISE') {
    //   this.filter.dc_no = row.dc_no;
    //   this.filter.dc_date = row.dc_date;
    //   // this.filter.groupby = 'DC_WISE_DETAILS';
    //   this.bsModalRef = this.modalService.show(ocrDcPrint, {
    //     keyboard: false,
    //     ignoreBackdropClick: true,
    //     class: "modal-lg compWidth-96",
    //   });
    //   this.bsModalRef.content.printdt = Object.assign({}, row);
    // }
    else if (this.filter.groupby == 'DATE_WISE') {
      this.filter.date = row.date;
      this.filter.groupby = 'DC_WISE';
    }

    // if(this.filter.groupby != 'DC_WISE') {
    this.getOrderList();
    // }
  }

  onbackbutton() {
    if (this.filter.groupby == 'DC_WISE_DETAILS') {
      this.filter.groupby = 'DC_WISE';
    } else if (this.filter.groupby == 'DC_WISE') {
      this.filter.groupby = 'DATE_WISE';
    } else {
      this.filter.groupby = 'MONTH_WISE';
      // this.working_days = 0;
      // this.year_balance = 0;
    }
    this.getOrderList();
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
  }

  applyFilter(): void {
    // this.filterPanel.close();
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      this.getOrderList();
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  getOrderList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    this.isLoadMask = this.purReport
      .getFactoryDelVsProcessReport(params)
      .then(function (res: any) {

        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        let temp = [];
        let obj = {};
        let colordata = 0;
        if (that.filter.groupby == 'MONTH_WISE') {
          res.data.forEach((element, ind) => {
            element.yr_plan = ind == 0 ? element.yr_plan : res.data[ind - 1].yr_need
            element.yr_need= element.yr_plan - element.tot_qty;
            element.need_monthavg = Math.round(element.yr_need/element.bal_month)
            element.need_dailyavg = Math.round(element.yr_need/element.bal_days)

            if (element.actual_days == 0) {
              element.actual_days = element.work_days;
            }
            if (element.tot_qty == 0) {
              element.actual_days = 0;
            }
            if (ind >= 5) {
              colordata = colordata + 1;
              if (colordata == 5) {
                colordata = 0;
              }

              element["background"] = that.colorList[colordata];

            }
            else
              element["background"] = that.colorList[ind];
            // element.tot_qty = element.ex_tot_qty + element.jo_tot_qty
          });
        }
        // console.log(res.data1, "response");
        if (that.filter.groupby == 'DATE_WISE') {
          res.data1.forEach((e, ind) => {
            temp.push({ date: e })
          });

          temp.forEach((e, ind) => {
            res.data['data'].forEach(el => {
              if (e.date == el['date']) {
                e.work_days = 1;
                e.dc_nos = el.dc_nos;
                e.month_bal = el.month_bal;
                e.month_avg = el.month_avg;
                e.balance_days = el.balance_days;
                e.tot_qty = el.tot_qty;
                e.planning_qty = el.planning_qty;
                e.yr_plan = el.yr_plan;
                e.yr_need = el.yr_need;
                e.year_avg = el.year_avg;
                e.pending_days = el.pending_days;
              }
              // else {
              //   temp[0].yr_plan = res.data['data'][0].yr_plan;
              // }
            });
          });
          temp.forEach((e, ind) => {
            e.ex_tot_qty = e.tot_qty ? e.tot_qty : 0;
            res.job_data['data'].forEach(el => {
              if (e.date == el['date']) {
                e.jo_tot_qty = el.jo_tot_qty
                e.tot_qty = e.jo_tot_qty + e.ex_tot_qty

              }
            });
          });
          temp.forEach((e, ind) => {
            if (!e.tot_qty && ind != 0) {
              e.tot_qty = 0;
              // e.work_days = 1;
              e.balance_days = temp[ind - 1].balance_days;
              e.yr_plan = temp[ind - 1].yr_need;
              // e.yr_plan = that.year_balance;
              e.yr_need = e.yr_plan - e.tot_qty;
              e.planning_qty = temp[ind - 1].month_bal;
              e.month_bal = e.planning_qty - e.tot_qty;

            }
            if (!e.tot_qty && ind == 0) {
              temp[0].tot_qty = 0;
              temp[0].work_days = 1;
              temp[0].pending_days = res.data['data'][0].pending_days;
              temp[0].balance_days = res.data['data'][0].balance_days;
              temp[0].yr_plan = res.data['data'][0].yr_plan;
              temp[0].yr_need = temp[0].yr_plan - temp[0].tot_qty;
              temp[0].planning_qty = res.data['data'][0].planning_qty;
              temp[0].month_bal = temp[0].planning_qty - e.tot_qty;
            }
            e.balance_days = res.data['data'][0].balance_days + 1;
            e.pending_days = res.data['data'][0].pending_days;

          })

          temp.forEach((e, ind) => {
            if (e.work_days && ind != 0) {
              // e.work_days = 1+temp[ind - 1].work_days;
              // e.balance_days = temp[ind - 1].balance_days - 1;
            }

          });

          temp.forEach((e, ind) => {
            res.leaveDet.forEach(el => {
              if (e.date == el.date) {
                e.is_leave = true;
              }
            });
          });
          let daysCount = 0;
          temp.forEach((e, ind) => {
            if (e.is_leave) {
              e.work_days = 0;
              e.pending_days = 0
              e.balance_days = 0;
              e.background = "indianred";
            }
            else {
              daysCount += 1;
              // e.pending_days = e[0].pending_days;
              e.work_days = daysCount;

              e.pending_days = e.pending_days - e.work_days;
              e.balance_days = e.balance_days - e.work_days;
              e.year_avg = (e.yr_need / e.balance_days).toFixed(0);
              e.month_avg = (e.month_bal / e.pending_days).toFixed(0);
            }
          });
          temp.forEach((e, ind) => {
            if (e.date == that.filter.date) {
              e.background = "deepskyblue";
            }
          });
          // console.log("res", temp);
          // res.data = temp;
          res.columns = res.data['columns'];
          that.gridOptions = {
            cols: res.cols,
            columns: res.columns,
            data: temp,
            loading: false,
          };
          that.exceldata = that.getData(res.columns, temp);
        }
        that.orderList = res.data;
        that.filter.year_qty = res.data[0].yr_plan;
        that.filter.tot_days = res.data[0].bal_days + res.data[0].work_days;
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Annual Factory Del Plan VS Process Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
        that.backbutton();
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;
        newrow[name] = row[prop];
      }
      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }
  backbutton() {
    if ($(".data-history-btn").length) {
      this.backbutExists = false;
    } else {
      this.backbutExists = true;
    }
  }
  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/FactoryDelVsProcessReport/FactoryDelVsProcessReport.ts